import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import PhotoSwipe from 'photoswipe';
import PhotoSwipeVideoPlugin from 'photoswipe-video-plugin';

/**
 * Load PhotoSwipe gallery
 */
class photoSwipe extends HTMLElement {
  /**
   * connectedCallback
   */
  connectedCallback() {
    const gallery = this.getAttribute('gallery');
    const children = this.getAttribute('children');

    const lightbox = new PhotoSwipeLightbox({
      gallery,
      children,
      pswpModule: PhotoSwipe,
      showHideAnimationType: 'fade',
    });

    // eslint-disable-next-line
    const videoPlugin = new PhotoSwipeVideoPlugin(lightbox, {});

    // add load model content
    lightbox.addFilter('domItemData', (itemData, el) => {
      const type = el.dataset.pswpType;
      if (type === 'html') {
        // eslint-disable-next-line
        itemData.type = 'html';
        // eslint-disable-next-line
        itemData.html = el.dataset.pswpHtml;
      }
      return itemData;
    });

    // don't swipe when interacting with model
    lightbox.on('pointerMove', (e) => {
      if (e.originalEvent.target.tagName.toLowerCase() === 'model-viewer') e.preventDefault();
    });

    // prvent ui hiding when clicking on model
    lightbox.on('pointerUp', (e) => {
      if (e.originalEvent.target.tagName.toLowerCase() === 'model-viewer') {
        let count = 0;
        const maxRuns = 10;
        const interval = setInterval(() => {
          e.originalEvent.target.closest('.pswp').classList.add('pswp--ui-visible');
          if (count >= maxRuns) clearInterval(interval);
          count += 1;
        }, 50);
      }
    });

    // run model when gallery was opened on that exact slide
    lightbox.on('openingAnimationEnd', () => {
      setTimeout(() => {
        const currentSlide = lightbox.pswp.currSlide;
        const slideElement = currentSlide.holderElement;
        const productModel = slideElement.querySelector('product-model button');
        if (productModel) productModel.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }, 500);
    });

    lightbox.init();
  }
}

customElements.define('photo-swipe', photoSwipe);
